// Temp file importing all es6 modules needed to also be in global scope
// Lives until all "old" modules are converted into es6 modules.
require('moment');
require('moment/locale/nb');
moment.locale('nb');
